import {OneTimeCodeDtoCodeTypeEnum} from "@/open_api/generated";

export import OneTimeCodeType = OneTimeCodeDtoCodeTypeEnum;
